import * as i0 from "@angular/core";
export class ExampleService {
    constructor() { }
}
ExampleService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ExampleService_Factory() { return new ExampleService(); }, token: ExampleService, providedIn: "root" });
